import { dateTimeSqlToDateTimeBR } from './date'

const createdUpdatedUser = (userName, date) => {
  return userName ? `${userName} em ${dateTimeSqlToDateTimeBR(date)}` : '-'
}

const statusTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Inativo', class: 'bg-danger' },
    1: { label: 'Ativo', class: 'bg-success' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const isSendTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Não', class: 'bg-info' },
    1: { label: 'Sim', class: 'bg-success' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

export { createdUpdatedUser, statusTranslate, isSendTranslate }
